__turbopack_context__.v({
  "card": "NewsCard-module-scss-module__HYXRGa__card",
  "dotAnnouncement": "NewsCard-module-scss-module__HYXRGa__dotAnnouncement",
  "dotFunding": "NewsCard-module-scss-module__HYXRGa__dotFunding",
  "dotLaunch": "NewsCard-module-scss-module__HYXRGa__dotLaunch",
  "dotMilestone": "NewsCard-module-scss-module__HYXRGa__dotMilestone",
  "dotOther": "NewsCard-module-scss-module__HYXRGa__dotOther",
  "dotPartnership": "NewsCard-module-scss-module__HYXRGa__dotPartnership",
  "eventDot": "NewsCard-module-scss-module__HYXRGa__eventDot",
  "eventLabel": "NewsCard-module-scss-module__HYXRGa__eventLabel",
  "eventType": "NewsCard-module-scss-module__HYXRGa__eventType",
  "head": "NewsCard-module-scss-module__HYXRGa__head",
  "headline": "NewsCard-module-scss-module__HYXRGa__headline",
  "logo": "NewsCard-module-scss-module__HYXRGa__logo",
  "logoFallback": "NewsCard-module-scss-module__HYXRGa__logoFallback",
  "meta": "NewsCard-module-scss-module__HYXRGa__meta",
  "metaLine": "NewsCard-module-scss-module__HYXRGa__metaLine",
  "sep": "NewsCard-module-scss-module__HYXRGa__sep",
  "source": "NewsCard-module-scss-module__HYXRGa__source",
  "teamName": "NewsCard-module-scss-module__HYXRGa__teamName",
  "time": "NewsCard-module-scss-module__HYXRGa__time",
});
